import { auth } from '@mesa/core/auth/better-auth';
import type { Scope } from '@mesa/core/auth/types';
import { scopesForRole } from '@mesa/core/auth/types';
import type { Organization } from '@mesa/core/org/index';
import { getOrgWithMembership } from '@mesa/core/org/queries';
import { createServerFn } from '@tanstack/react-start';
import { getRequestHeaders } from '@tanstack/react-start/server';

// Auth bootstrap composite — resolves session + org + org list in a single round-trip.
// Bypasses baseAuthMiddleware because it IS the auth resolution layer for the org layout.
export const loadOrgLayout = createServerFn({ method: 'GET' })
  .validator((data: { orgSlug: string }) => data)
  .handler(async ({ data: { orgSlug } }) => {
    const headers = getRequestHeaders();
    const session = await auth.api.getSession({ headers });
    if (!session) return null;

    const [orgResult, orgs] = await Promise.all([
      getOrgWithMembership(orgSlug, session.user.id),
      auth.api.listOrganizations({ headers }) as Promise<Organization[]>,
    ]);

    if (!orgResult) return { session, org: null, orgs };

    const org = {
      id: orgResult.org.id,
      slug: orgResult.org.slug,
      name: orgResult.org.name,
      role: orgResult.member.role,
      scopes: scopesForRole(orgResult.member.role) as Scope[],
    };

    return { session, org, orgs };
  });
